import type { ReportValueType } from '~/presentation/reports/common/type';
import type { ReportColumnLayout } from '../../types';

import { GInlineCenter } from '~/presentation/ui';
import { Text } from '@shopify/polaris';

interface ISummaryCellProps {
  currentValue?: string | null | number;
  previousValue?: ReportValueType;
  showPrevious?: boolean;
  columnLayout: ReportColumnLayout;
}
export const SummaryCell = ({
  currentValue,
  previousValue,
  showPrevious,
  columnLayout,
}: ISummaryCellProps) => {
  return (
    <GInlineCenter flexDirection="column" align={columnLayout.align} gap="100" paddingBlock="200">
      <Text as="span" variant="bodySm" fontWeight="semibold">
        {currentValue}
      </Text>
      {showPrevious && typeof previousValue !== 'object' && (
        <Text as="span" variant="bodySm" fontWeight="semibold" tone="subdued">
          {previousValue}
        </Text>
      )}
    </GInlineCenter>
  );
};
